var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import omit from 'omit.js';
import React, { forwardRef, memo, useMemo } from 'react';
import Auto from '../Auto';
import Fixed from '../Fixed';
import FlexLayout from '../FlexLayout';
import { selectorPrefix } from '../FlexLayout';
/**
 * TCBLayout
 * @constructor
 * @param _props
 * @param ref
 */
var TCBLayout = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_props, ref) {
  var _a;
  var wrapClassName = _props.wrapClassName,
    wrapStyle = _props.wrapStyle,
    tProps = _props.tProps,
    tSplit = _props.tSplit,
    cProps = _props.cProps,
    bProps = _props.bProps,
    bSplit = _props.bSplit,
    props = __rest(_props, ["wrapClassName", "wrapStyle", "tProps", "tSplit", "cProps", "bProps", "bSplit"]);
  // @ts-ignore
  var TProps = omit(tProps, ['children']);
  // @ts-ignore
  var CProps = omit(cProps, ['children']);
  // @ts-ignore
  var BProps = omit(bProps, ['children']);
  var classList = useMemo(function () {
    var _a;
    return classNames("".concat(selectorPrefix, "-trblc"), (_a = {}, _a["".concat(selectorPrefix, "-trblc-no-autofix")] = cProps && 'autoFixed' in cProps && !cProps.autoFixed, _a), wrapClassName !== null && wrapClassName !== void 0 ? wrapClassName : '');
  }, [cProps]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classList,
    style: wrapStyle !== null && wrapStyle !== void 0 ? wrapStyle : {}
  }, /*#__PURE__*/React.createElement(FlexLayout, __assign({}, props !== null && props !== void 0 ? props : {}, {
    className: classNames("".concat(selectorPrefix, "-tc-layout"), (_a = props === null || props === void 0 ? void 0 : props.className) !== null && _a !== void 0 ? _a : ''),
    direction: "vertical"
  }), /*#__PURE__*/React.createElement(Fixed, __assign({
    collapseDirection: "T"
  }, TProps !== null && TProps !== void 0 ? TProps : {}), tProps === null || tProps === void 0 ? void 0 : tProps.children), tSplit, /*#__PURE__*/React.createElement(Auto, __assign({}, CProps !== null && CProps !== void 0 ? CProps : {}), cProps === null || cProps === void 0 ? void 0 : cProps.children), bSplit, /*#__PURE__*/React.createElement(Fixed, __assign({
    collapseDirection: "B"
  }, BProps !== null && BProps !== void 0 ? BProps : {}), bProps === null || bProps === void 0 ? void 0 : bProps.children)));
}));
TCBLayout.displayName = 'TCBLayout';
export default TCBLayout;